import { render, staticRenderFns } from "./ResellerDocuments.vue?vue&type=template&id=106d550a"
import script from "./ResellerDocuments.vue?vue&type=script&lang=js"
export * from "./ResellerDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports